
































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
@Component
export default class ModalBox extends Vue {
  @Prop({
    default: () => {
      return {};
    },
  })
  private modalJson: any;
  @Prop({
    default: () => {
      return [];
    },
  })
  private selectDataJson: any;
  @Prop()
  private modalTitle!: string;
  private moment: any = moment;
  private format: string = 'MMMM Do YYYY, h:mm:ss a';
  private maskClosable: boolean = false;
  private visible: boolean = false;
  private atextareaDisabled: boolean = true;
  private modalDisabled: boolean = false;
  private modelWidth: number = 900;
  private index: number = 0; // 新增的值为 -1
  private modalBoxType: string = '';
  private showModal(boo: boolean, index: number, type: string) {
    this.visible = true;
    this.modalDisabled = boo;
    this.index = index;
    this.modalBoxType = type;
  }
  private async showModalFromGoods(boo: boolean, index: number, type: string) {
    this.visible = true;
    this.modalDisabled = boo;
    this.index = index;
    this.modalBoxType = type;
    const data = this.$store.state.goodsInfo;
    const args = {
      productNumber: data.productNumber,
    };
    await this.getTrackingAll(args);
    this.$set(this.modalJson, 'number', data.goodsDelivering);
  }
  private async showModalFromArrangeGoods(boo: boolean, index: number, type: string) {
    this.visible = true;
    this.modalDisabled = boo;
    this.index = index;
    this.modalBoxType = type;
    const store = this.$store.state.arrangeGoodsInfo;
    const data = store.mergeNumObj;
    const args = {
      productNumber: data.productNumber,
    };
    await this.getTrackingAll(args);
    this.$set(this.modalJson, 'number', data.goodsDelivering);
  }
  private copyProductNumber(id: string) {
    const Url: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    Url.select();
    document.execCommand('Copy');
    this.$message.info('Copy Success !!');
  }
  private emitEmpty(box: any, oKey: string, value: any) {
    const inputBox: HTMLInputElement = this.$refs[box] as HTMLInputElement;
    inputBox.focus();
    this.$set(this.modalJson, oKey, value);
  }
  private onChangeDate(date: any, dateString: string) {
    this.$set(this.modalJson, 'trackingTime', date);
  }
  private async handleOk(e: any) {
    const that = this;
    this.visible = false;
    // const time = this.modalJson.trackingTime;
    // this.$emit(this.modalJson, 'trackingTime', moment(time).format('YYYY-MM-DD'));
    if ( this.modalTitle === '创建' ) {
      if (this.modalJson.productName === '') {
        this.$message.error('保存失败!! 请认真填写产品名称!!');
        return false;
      } else {
        // 创建 sql
        const url = '/api/getInsertTracking';
        const args = this.modalJson;
        const modalBoxType = this.modalBoxType;
        this.axios.post(url, args).then((res) => {
          // 扣除goods里面数据 或者 变更goodsStatus 状态
          if (modalBoxType === 'GoodsList') {
            // goods 表中,修改数据
            that.sendAmazon();
          } else if (modalBoxType === 'ArrangeGoodsList') {
            // goods 表中,修改数据, 数据是  数组
            this.sert();

          }
          that.$router.push({
            path: '/Tracking',
          });
        });
      }
      // push 新数据添加到 老数组
    } else if ( this.modalTitle === '修改' ) {
      if (this.modalJson.productName === '') {
        this.$message.error('保存失败!! 请认真填写产品名称!!');
        return false;
      } else {
        const url = '/api/getUpdateTracking';
        const args = this.modalJson;
        this.axios.post(url, args).then((res) => {
          that.$emit('changeDataJson', '修改', this.modalJson, this.index);
          that.$router.push({
            path: '/Tracking',
          });
        });
      }
      // 修改后数据 在 老数组 中修改
      // 已经自动修改
    }
  }
  private async sert() {
    const checkedList = this.$store.state.arrangeGoodsInfo.checkedList;
    for (const list of checkedList) {
      const res: any = await this.sendAmazonArr(list);
      if (res && res.code !== 12) {
        this.$message.error('发货 扣除 ,tracking 成功, 保存失败!! 请重新发货');
      }
    }
    this.$emit('changeDataJson', '创建', this.modalJson, this.index);
  }
  private sendAmazonArr(args: any) {
    const that = this;
    return new Promise((resolve, reject) => {
      // 清空数组this.$store.state.arrangeGoodsInfo;
      const url: string = '/api/changeGoodsData';
      that.axios.post(url, args).then((res) => {
        resolve(res.data);
      });
    });
  }
  private sendAmazon() {
    const that = this;
    // 清空数组
    const args = this.$store.state.goodsInfo;
    const url: string = '/api/changeGoodsData';
    this.axios.post(url, args).then((res) => {
      const dataJson = res.data;
      if (dataJson.code === 12) {
        that.$emit('changeDataJson', '创建', this.modalJson, this.index);
      } else {
        that.$message.error('发货 扣除 ,tracking 成功, 保存失败!! 请重新发货');
      }
    });
  }
  private async handleChange(value: string, type: string) {
    const that = this;
    if ( type === 'pmName' ) {
      const url = '/api/getPMTrackingNumber';
      const args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        that.selectDataJson.splice(2, 1, res.data.data);
      });
    } else if ( type === 'productName' ) {
      const args = {
        productName: value,
      };
      await this.getTrackingAll(args);
    }
    // this.$set(this.modalJson, type, value);
    // this.modalJson[type] = value;
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        if (res.data.data && res.data.data[0]) {
          const data = res.data.data[0];
          Object.assign(this.modalJson, {
            pmName: data.pmName,
            productName: data.productName,
            productNumber: data.productNumber,
            asin: data.asin,
            store: data.store,
            brand: data.brand,
          });
          resolve();
        } else {
          reject();
        }
      });
    });
  }
  private handleCancel() {
    this.visible = false;
    this.$router.push({
      path: '/Tracking',
    });
  }
}
